import { combineReducers } from "redux";
import MemberReducer from "./MemberReducer";
import CityReducer from "./CityReducer";
import LoggedUserReducer from "./LoggedUserReducer";
import UserReducer from "./UserReducer";
import PromotionReducer from "./PromotionReducer";
import GroupProductReducer from "./GroupProductReducer";
import NotificationReducer from "./NotificationReducer";
import UserGroupReducer from "./UserGroupReducer";
import UserGroupDetailReducer from "./UserGroupDetailReducer";
import PermissionReducer from "./PermissionReducer";

const reducers = combineReducers({
  permission: PermissionReducer,
  userGroupDetail: UserGroupDetailReducer,
  userGroup: UserGroupReducer,
  member: MemberReducer,
  city: CityReducer,
  loggedUser: LoggedUserReducer,
  users: UserReducer,
  promotions: PromotionReducer,
  groupProducts: GroupProductReducer,
  notifications: NotificationReducer,
});

export default reducers;
